export default {
  sys: {
    title: 'Hankyong National University. - Integrated Login'
  }
}
